import templateUrl from 'emun.on-demand/designer-portal.htm'
import resolve from 'ioc/resolve'
import basicController from 'servicestack/basic.controller.properties'


class DesignerPortalController {
    constructor($state) {
        basicController(this)
        const $ctrl = this;
        $ctrl.navs = $state.getNav('designer-portal');
    }
}

let DesignerPortalComponent = {
    bindings: {
    },
    controller: DesignerPortalController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default DesignerPortalComponent;